<div class="container">
  <div class="container__image">
    <img class="image" [src]="imgSrc" alt="#">
  </div>
  <div class="container__content">
    <ng-content></ng-content>
  </div>
</div>
